import * as React from 'react';
import { IconProps } from './icon-props';

const LabelBgIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="106"
    height="18"
    fill="none"
    viewBox="0 0 106 18"
    {...props}
  >
    <path
      fill="currentColor"
      d="M.5 18h105L97.245 2.829C96.915 2.4 95.925 0 90.972 0H4.128S2.43-.042 1.463.88C.497 1.8.5 3.455.5 3.455z"
    ></path>
  </svg>
);

export default LabelBgIcon;
